/**
 * Loads the address map (Leaflet + country GeoJSON, ~375 KB) only on pages that
 * actually render the addresses module, via a code-split dynamic import.
 */
export const ADDRESS_MAP_SELECTOR = '.addresses-module-container[data-address-map]';

type AddressMapModule = { AddressMapInitializer: new () => { init(): void } };

export class AddressMapLoader {
	constructor(private readonly load: () => Promise<AddressMapModule> = () => import('./AddressMapInitializer')) {}

	init(): void {
		if (!document.querySelector(ADDRESS_MAP_SELECTOR)) return;

		this.load()
			.then((module) => new module.AddressMapInitializer().init())
			.catch((error: unknown) => console.error('Address map could not be loaded', error));
	}
}
